// scripts/api.js
import axios from 'axios';
import CryptoJS from 'crypto-js';
import MiniSearch from 'minisearch'
import Bugsnag from '@bugsnag/js'

let miniSearch = new MiniSearch({
    fields: ['marques', 'nom', 'siteInternet'],
    storeFields: ['id','nom', 'position'],
    idField: 'id'
})

const findNearest = (stores, position)=>{

    stores = stores.filter(marker => {
        return marker.typeEntiteLegale !== 'DIGITALE' && marker.displayAdresse
    }).sort((a,b)=>{
        return computeDistance(a.position, position)>computeDistance(b.position, position)?1:-1
    })

    return stores[0];
}

const trackRequest = async (stores, position) => {

    const store = findNearest(stores, position);

    if( sessionStorage.getItem('tracked') )
        return

    try {

        sessionStorage.setItem('tracked', '1');

        const reverse_api_url = 'https://api-adresse.data.gouv.fr/reverse/';
        const reverse_res = await axios.get(reverse_api_url, { params: {lat:position[0], lon:position[1]} });

        const address = reverse_res.data.features[0].properties;

        const coordinates = store.position[1]+','+store.position[0]+';'+position[1]+','+position[0]
        const route_api_url = 'https://router.project-osrm.org/route/v1/driving/'+coordinates+'?overview=false';

        let data = {
            timestamp: new Date().getTime(),
            latLng: position,
            city: address.city,
            postCode: address.postcode,
            id: store.id,
            distance: 0,
            duration: 0,
            reparationChaussures: store.reparationChaussures,
            reparationTextiles: store.reparationTextiles
        }

        try {

            const route_res = await axios.get(route_api_url);

            data.distance = Math.round(route_res.data.routes[0].distance/100)/10
            data.duration = Math.round(route_res.data.routes[0].duration/60)

        } catch (error) {

            Bugsnag.notify(new Error(error))
        }

        const api_url = process.env.VUE_APP_TRACK_API_URL;
        await axios.post(api_url, data);

    } catch (error) {

        Bugsnag.notify(new Error(error))
        sessionStorage.removeItem('tracked');
    }
}

const search = async (query, limit) => {

    const api_url = 'https://api-adresse.data.gouv.fr/search/';

    if (query.replace(/ /g, '').length < 3) return [];

    const params = {
        q: query,
        autocomplete: 1,
        limit: limit
    };

    trackEvent('search', {search_term:query});

    try {

        const res = await axios.get(api_url, { params: params });

        let addresses = [];
        res.data.features.forEach(feature => {
            if( feature.properties.score > 0.4 ){
                addresses.push({
                    id: feature.properties.id,
                    score: feature.properties.score,
                    type: feature.properties.type,
                    label: feature.properties.label,
                    latLng: feature.geometry.coordinates.reverse()
                });
            }
        });

        let stores = [];
        miniSearch.search(query, { prefix: true, fuzzy: 0.2, combineWith: 'AND' }).forEach(store => {
            stores.push({
                id: store.id,
                score: store.score,
                type: 'store',
                label: store.nom,
                latLng: store.position
            });
        });

        if( !addresses.length && !stores.length )
            trackEvent('search_no_result', {search_term:query});

        return {addresses:addresses, stores: stores, length: addresses.length+stores.length};

    } catch (error) {

        Bugsnag.notify(new Error(error))
        return [];
    }
};

const autocomplete = async (query, limit) => {

    const api_url = 'https://api-adresse.data.gouv.fr/search/';

    if (query.replace(/ /g, '').length < 3) return [];

    const params = {
        q: query,
        autocomplete: 1,
        limit: limit
    };

    trackEvent('search', {search_term:query});

    try {

        const res = await axios.get(api_url, { params: params });

        let addresses = [];

        res.data.features.forEach(feature => {
            if( feature.properties.score > 0.4 ){
                addresses.push({
                    id: feature.properties.id,
                    score: feature.properties.score,
                    type: feature.properties.type,
                    label: feature.properties.label,
                    latLng: feature.geometry.coordinates.reverse()
                });
            }
        });

        if( !addresses.length )
            trackEvent('search_no_result', {search_term:query});

        return addresses

    } catch (error) {

        Bugsnag.notify(new Error(error))
        return [];
    }
};

const getAllPoints = async () => {

    const api_url = process.env.VUE_APP_IPSO_API_URL;

    try {

        const res = await axios.get(api_url);

        miniSearch.addAll(Object.values(res.data))
        return res.data

    } catch (error) {
        Bugsnag.notify(new Error(error))
        return []
    }
}

/**
 * Computes the distance between two geographical coordinates using the Haversine formula.
 *
 * @param {Array<number>} markerPosition - The [latitude, longitude] of the first position (e.g., a marker).
 * @param {Array<number>} currentPosition - The [latitude, longitude] of the second position (e.g., current location).
 * @return {number} The distance between the two positions in meters.
 */
const computeDistance = (markerPosition, currentPosition) => {

    const lat1 = markerPosition[0];
    const lon1 = markerPosition[1];

    const lat2 = currentPosition[0];
    const lon2 = currentPosition[1];

    const R = 6371e3;
    const p1 = lat1 * Math.PI/180;
    const p2 = lat2 * Math.PI/180;
    const deltaP = p2 - p1;
    const deltaLon = lon2 - lon1;
    const deltaLambda = (deltaLon * Math.PI) / 180;
    const a = Math.sin(deltaP/2) * Math.sin(deltaP/2) +
        Math.cos(p1) * Math.cos(p2) *
        Math.sin(deltaLambda/2) * Math.sin(deltaLambda/2);

    return 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)) * R;
}

const decode = (encryptedHex) => {
    const bytes = CryptoJS.AES.decrypt(encryptedHex,process.env.VUE_APP_SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
}

const trackEvent = (event_name, params)=>{

    if( event_name.length )
        params.event = event_name

    console.log('Track event : '+JSON.stringify(params))

    window.dataLayer.push(params);
}

const formatMarker = (marker) => {

    let type = []

    if( marker.serviceDomicile )
        type.push('serviceDomicile')

    if( marker.correspondance )
        type.push('correspondance')

    if( marker.displayAdresse )
        type.push('boutique')

    return {
        shop_name: marker.nom,
        cordoniers: marker.reparationChaussures,
        retoucheurs: marker.reparationTextiles,
        collect_type: type.join('|'),
        shop_city: marker.ville,
        shop_zip: marker.codePostal
    }
}

export {search, getAllPoints, computeDistance, decode, trackEvent, formatMarker, trackRequest, autocomplete, findNearest}